import React from 'react';
import { shape, number, string, arrayOf } from 'prop-types';
import { round } from 'lodash';
import cx from 'classnames';
import WithSubtitle from 'components/WithSubtitle';
import Trendline from 'components/Trendline';
import BatteryIcon from 'components/BatteryIcon';
import LocationStatusIcon from 'components/LocationStatusIcon';
import deviceStatus from 'propTypes/deviceStatus';

import styles from './LocationsListItem.scss';

/**
 * Accumulate values by summing each value with the total of the values
 * before it.
 * @param {Array} values
 */
function accumulatePreviousValues(values) {
  return values.reduce((acc, v, index) => {
    if (index === 0) return [v];
    return [...acc, v + acc[index - 1]];
  }, []);
}

function LocationsListItem({ location }) {
  const { trackingDevice, name } = location;
  const { hitsToday, id: deviceId, name: deviceName, batteryVoltage } = trackingDevice;

  const accumulatedHitsToday = accumulatePreviousValues(hitsToday);
  const status = trackingDevice.status;

  return (
    <div className={cx(styles.main, styles[`status-${status}`])}>
      <span className={styles.location}>
        <LocationStatusIcon className={styles.locationIcon} status={status} />
      </span>
      <div className={styles.textContainer}>
        <WithSubtitle className={styles.name} title={deviceName || deviceId}>
          {name}
        </WithSubtitle>
      </div>
      <div className={styles.dataContainer}>
        <WithSubtitle className={styles.battery} title={`${round(batteryVoltage, 1)}V`}>
          <BatteryIcon className={styles.batteryIcon} batteryVoltage={batteryVoltage} />
        </WithSubtitle>
        <WithSubtitle className={styles.sparkLine} title="hits">
          <Trendline trendData={accumulatedHitsToday} width={32} height={12} />
        </WithSubtitle>
      </div>
    </div>
  );
}

LocationsListItem.propTypes = {
  location: shape({
    name: string.isRequired,
    trackingDevice: shape({
      status: deviceStatus.isRequired,
      hitsToday: arrayOf(number).isRequired,
      id: string.isRequired,
      name: string,
      batteryVoltage: number.isRequired,
    }),
  }).isRequired,
};

export default LocationsListItem;



// WEBPACK FOOTER //
// ./src/components/DataPanel/Overview/LocationsListItem/index.js